"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    getAllLabels: function getAllLabels() {
        return {
            "vegetarian": "wixrest-simple-dish",
            "vegan": "wixrest-special-dish",
            "gluten_free": "wixrest-size-dish",
            "organic": "wixrest-fax",
            "alcoholic": "wixrest-mail",
            "spicy": "wixrest-payments"
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/DishLabels.js
// module id = 928
// module chunks = 0